import { ParameterType } from '@/study-search/enums';
import { RouteParams } from 'vue-router';

import { IQuery, IUrlContent } from '../../interfaces';
import PageNumberParser from './PageNumberParser';
import { ParsedFilter } from '../generalizations/ParsedFilter';
import PathParser from './PathParser';
import { PortalDefinition } from '../definition';
import QueryParser from './QueryParser';
import SearchCriteriaParser from './SearchCriteriaParser';
import store from '@/study-search/store';
import SortingParser from './SortingParser';

class UrlParser {
	public async parse(
		params: RouteParams,
		path: string,
		query: IQuery,
		portalDefinition: PortalDefinition
	): Promise<void> {
		const filters = this.reconstituteFiltersFromUrl(params, query, portalDefinition);

		const page = params.page ? (params.page as string) : undefined;
		const pageNumber: number = PageNumberParser.getPageNumberFromUrl(page, query.page);

		const sorting = SortingParser.getSortingFromUrl(query.sorting);

		const portalType = params.portal_type as string;
		const payload: IUrlContent = {
			filters,
			portalType,
			pageNumber,
			path,
			sorting
		};
		await store.actions.processUrlContent(payload);
	}

	private reconstituteFiltersFromUrl(
		params: RouteParams,
		query: IQuery,
		portalDefinition: PortalDefinition
	): ParsedFilter[] {
		const filtersFromPath = PathParser.parse(params, portalDefinition);
		const filtersFromSearchCriteria = SearchCriteriaParser.parse(query.search);
		const filtersFromQuery = QueryParser.parse(query);
		const filters = ParsedFilter.combine(
			ParsedFilter.combine(filtersFromPath, filtersFromSearchCriteria),
			filtersFromQuery
		);

		return this.applyUrlFiltersConstraints(filters, portalDefinition);
	}

	private applyUrlFiltersConstraints(filters: ParsedFilter[], portalDefinition: PortalDefinition): ParsedFilter[] {
		filters = filters.filter(
			(filter) =>
				portalDefinition.isValidFilter(filter.type) || !store.getters.isStructuredFilter(filter.type as ParameterType)
		);

		const filterContinent = filters.find((_) => (_.type as ParameterType) === ParameterType.CONTINENT);
		if (filterContinent !== null && filters.some((_) => (_.type as ParameterType) === ParameterType.COUNTRY)) {
			filterContinent?.clear();
		}

		return filters;
	}
}

export default new UrlParser();
